"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var gateway_request_type_1 = require("./../../../services/gateway-control/gateway-request-type");
var base_gateway_service_request_1 = require("./../../../services/gateway-control/services/base-gateway-service-request");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST service-targeted invoke operation request.
 */
var GatewayServiceInvokeOperationRequest = /** @class */ (function (_super) {
    __extends(GatewayServiceInvokeOperationRequest, _super);
    /**
     * Create a new GatewayServiceInvokeOperationRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param serviceId  the service id
     * @param operationName  the name of the operation to invoke
     * @param input  optional input data in the form of a JSON string
     */
    function GatewayServiceInvokeOperationRequest(sessionId, serviceId, operationName, input) {
        var _this = _super.call(this, sessionId, serviceId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.INVOKE_SERVICE_OPERATION;
        _this.operationName = operationName;
        _this.input = input;
        return _this;
    }
    return GatewayServiceInvokeOperationRequest;
}(base_gateway_service_request_1.BaseGatewayServiceRequest));
exports.GatewayServiceInvokeOperationRequest = GatewayServiceInvokeOperationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/services/service-invoke-operation-request.js
// module id = 1964
// module chunks = 1